import clsx from "clsx";
import React from "react";
import { BaseText } from "web/react/emo/shared/components/base-text";
import * as styles from "./circle-logo.css";

export interface CircleLogoProps {
    size: "xs" | "sm" | "md" | "lg" | "xl";
    name: string;
    imageURL?: string;
    altText?: string;
}

const textStyleMap = {
    xs: "hero-xs",
    sm: "hero-s",
    md: "hero",
    lg: "hero-l",
    xl: "hero-xl",
} as const;

export function CircleLogo({ size, name, imageURL, altText }: CircleLogoProps): React.ReactElement {
    return (
        <div data-testid="circle-logo" className={styles.border}>
            {imageURL ? (
                <img
                    className={styles.circleLogoRecipe({ size })}
                    src={imageURL}
                    alt={altText || `${name}-logo`}
                />
            ) : (
                <BaseText
                    className={clsx(
                        styles.circleLogoRecipe({ size }),
                        size === "xs" ? styles.initialXs : styles.initial
                    )}
                    textStyle={textStyleMap[size]}
                    color={"primary"}
                    aria-label={name}
                    upperCase
                    as={"p"}
                >
                    {name[0]}
                </BaseText>
            )}
        </div>
    );
}
